"use strict";
/**
 * Created by rouven on 24.02.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var with_tooltip_1 = __importDefault(require("@wikom/with-tooltip"));
var Header = function (_a) {
    var grid = _a.grid, columns = _a.columns, activeSort = _a.activeSort, handleSort = _a.handleSort;
    return react_1["default"].createElement("tr", null, columns.map(function (column, key) {
        var _a = column.props, name = _a.name, className = _a.className, tooltip = _a.tooltip, idx = _a.idx, ThComponent = _a.ThComponent, _b = _a.cellWidth, cellWidth = _b === void 0 ? false : _b, _c = _a.sortable, sortable = _c === void 0 ? true : _c;
        if (ThComponent) {
            return react_1["default"].createElement(ThComponent, { grid: grid, name: name, key: key, idx: idx, cellWidth: cellWidth });
        }
        var classNames = [];
        var thProps = {
            key: key
        };
        var sortOrder = null;
        switch (typeof className) {
            case 'object':
                if (className.th) {
                    classNames.push(className.th);
                }
                break;
            case 'string':
                classNames.push(className);
                break;
        }
        if (activeSort && activeSort.indexOf(idx) !== -1) {
            sortOrder = activeSort.indexOf(idx) === 0 ? 'asc' : 'desc';
            classNames.push('sort-' + sortOrder);
        }
        if (sortable === true && typeof handleSort === 'function') {
            thProps.onClick = function () { return handleSort(idx, sortOrder !== 'asc'); };
            classNames.push('sortable');
        }
        thProps.className = classNames.join(' ');
        var thInner = react_1["default"].createElement("span", { className: "table-head-title" }, (0, with_tooltip_1["default"])(tooltip)(name));
        return react_1["default"].createElement("th", __assign({}, thProps), cellWidth ? (react_1["default"].createElement("div", { style: { 'width': cellWidth } }, thInner)) : thInner);
    }));
};
exports["default"] = Header;
